(() => {
  const normalize = (value) => value
    .toLocaleLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[0@]/g, 'o')
    .replace(/[1!|]/g, 'i')
    .replace(/[3]/g, 'e')
    .replace(/[4]/g, 'a')
    .replace(/[5$]/g, 's')
    .replace(/[7]/g, 't')
    .replace(/[^a-zа-яіїєґčďěňřšťůž\s]/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const blockedFragments = [
    'fuck', 'shit', 'bitch', 'cunt', 'asshole', 'motherfuck',
    'nigger', 'faggot',
    'хуй', 'хуе', 'хер', 'пизд', 'бляд', 'блять', 'сука', 'еба', 'ёба', 'їба', 'йоб', 'мудак',
    'kokot', 'pica', 'píča', 'kurva', 'hovno', 'zmrd'
  ].map(normalize);

  const containsBlockedLanguage = (value) => {
    const text = ` ${normalize(value)} `;
    return blockedFragments.some((fragment) => fragment && text.includes(fragment));
  };

  const showError = (form, message) => {
    const error = form.querySelector('[data-wh99-review-error]');
    if (!error) return;
    error.textContent = message;
    error.classList.add('is-visible');
    error.focus({ preventScroll: true });
    error.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const clearError = (form) => {
    const error = form.querySelector('[data-wh99-review-error]');
    if (!error) return;
    error.textContent = '';
    error.classList.remove('is-visible');
  };



  // V168: self-contained review dialog controller.
  // Do not depend on the large WHITEHOLE V67 bootstrap: product-page errors
  // elsewhere must never disable the Write a review button.
  const initReviewDialogs = (root = document) => {
    root.querySelectorAll('[data-wh67-reviews]').forEach((section) => {
      const dialog = section.querySelector('[data-wh67-review-dialog]');
      const openButton = section.querySelector('[data-wh67-review-open]');
      if (!dialog || !openButton) return;

      if (section.dataset.wh168DialogReady === 'true') return;
      section.dataset.wh168DialogReady = 'true';

      let previousFocus = null;

      const setOpen = (value) => {
        if (value) {
          previousFocus = document.activeElement;
          dialog.hidden = false;
          dialog.setAttribute('aria-hidden', 'false');
          document.body.classList.add('wh67-modal-open');
          requestAnimationFrame(() => {
            const focusTarget = dialog.querySelector('input:not([type="hidden"]), textarea, button, [href], [tabindex]:not([tabindex="-1"])');
            focusTarget?.focus({ preventScroll: true });
          });
        } else {
          dialog.hidden = true;
          dialog.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('wh67-modal-open');
          (previousFocus || openButton)?.focus?.({ preventScroll: true });
        }
      };

      openButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setOpen(true);
      });

      section.querySelectorAll('[data-wh67-review-close]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          setOpen(false);
        });
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) setOpen(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !dialog.hidden) setOpen(false);
      });
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('form.wh99-review-form:not([data-wh99-ready])').forEach((form) => {
      form.dataset.wh99Ready = 'true';

      form.addEventListener('input', () => clearError(form));
      form.addEventListener('submit', (event) => {
        clearError(form);

        const honeypot = form.querySelector('[data-wh99-review-honeypot]');
        if (honeypot?.value) {
          event.preventDefault();
          showError(form, 'Unable to submit this review. Please try again.');
          return;
        }

        const title = form.querySelector('[name="contact[Review title]"]')?.value || '';
        const body = form.querySelector('[name="contact[body]"]')?.value || '';
        const name = form.querySelector('[name="contact[Name]"]')?.value || '';
        const combined = `${name} ${title} ${body}`;

        if (containsBlockedLanguage(combined)) {
          event.preventDefault();
          showError(form, 'Please remove offensive or abusive language before submitting your review.');
          return;
        }

        const links = body.match(/https?:\/\//gi) || [];
        if (links.length > 1) {
          event.preventDefault();
          showError(form, 'Reviews can contain no more than one link.');
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => { init(); initReviewDialogs(); });
  document.addEventListener('shopify:section:load', (event) => { init(event.target); initReviewDialogs(event.target); });
  if (document.readyState !== 'loading') { init(); initReviewDialogs(); }
})();
